import React from "react";
import MinusIcon from "./images/MinusIcon";
import PlusIcon from "./images/PlusIcon";

const WidgetContentAdjustmentBoxLarge = ({
  title,
  children,
  Default,
  onClickPlus,
  onClickMinus,
  className,
  arialabel,
  increaseButton,
  decreaseButton
}) => {
  function eventTriggerMinus(event) {
    if (event.type === "click" || (event.type === "keypress" && event.key === "Enter")) {
      onClickMinus();
    }
  }
  function eventTriggerPlus(event) {
    if (event.type === "click" || (event.type === "keypress" && event.key === "Enter")) {
      onClickPlus();
    }
  }

  return (
    <div
      className={`WidgetContentAjustmentBoxBg ${className}`}
      role="region"
      aria-label={arialabel}
    >
      <p className="WidgetContentAjustmentBoxBgP ">
        {children}
        {title}
      </p>
      <div className="WidgetContentAjustmentBoxBgDefaultAdjustmentContainer ">
        <div
          tabIndex={0}
          aria-label={increaseButton}
          typeof="button"
          className="WidgetContentAjustmentBoxBgDefaultAdjustmentContainerArrowBtn"
          onClick={eventTriggerMinus}
          onKeyPress={eventTriggerMinus}>
          <MinusIcon />
        </div>
        <p style={{ fontSize: "1.em" }}>{Default}</p>
        <div
          tabIndex={0}
          typeof="button"
          aria-label={decreaseButton}
          className="WidgetContentAjustmentBoxBgDefaultAdjustmentContainerArrowBtn"
          onClick={eventTriggerPlus}
          onKeyPress={eventTriggerPlus}>
          <PlusIcon />
        </div>
      </div>
    </div>
  );
};

export default WidgetContentAdjustmentBoxLarge;
